<div class="pagination" *ngIf="showPagination">
  <mat-paginator
    class="pagination-control"
    [length]="totalItems"
    [pageSize]="pageSize"
    [pageIndex]="page - 1"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPage($event)"
    aria-label="Paginacao de produtos"
  ></mat-paginator>
</div>
